module.exports = __webpack_public_path__ + "static/img/db.70a28322.jpg";